/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PracticeStrictHttpResponse } from '../../practice-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientEncounterDetailModel } from '../../models/patient-encounter-detail-model';

export interface PatientPatientEncounterDetailPatientIdGet$Params {
  patientId: string;
  index?: number | null;
  pageSize?: number | null;
}

export function patientPatientEncounterDetailPatientIdGet(http: HttpClient, rootUrl: string, params: PatientPatientEncounterDetailPatientIdGet$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<PatientEncounterDetailModel>> {
  const rb = new RequestBuilder(rootUrl, patientPatientEncounterDetailPatientIdGet.PATH, 'get');
  if (params) {
    rb.path('patientId', params.patientId, {});
    rb.query('index', params.index, {});
    rb.query('pageSize', params.pageSize, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as PracticeStrictHttpResponse<PatientEncounterDetailModel>;
    })
  );
}

patientPatientEncounterDetailPatientIdGet.PATH = '/Patient/PatientEncounterDetail/{patientId}';
